<template>
  <div class="enter-pincode">
    <form
      class="form"
      action=""
      v-on:submit.prevent="sendForm"
    >

      <div class="form__fields">
        <h1 v-html="'Укажите код подключения к&nbsp;игре'"></h1>

        <p>
          Введите 4-значный код,
          сообщенный вам менеджером или
          указанный в описании под видео.
        </p>

        <div class="form-input__wrapper">
          <code-box
            v-bind:charCount="codeDigits"
            v-bind:autosend="autosendCode"
            v-on:fullCode="sendForm"
            v-model.trim="form.pincode" />
        </div>
      </div>

      <div class="form__controls">
        <button
          class="dark button wide"
          v-bind:class="{ inactive: !isCodeValid }"
        >В бой</button>
      </div>
    </form>

    <div class="check-online">
      <h3>Проверьте подключение к&nbsp;сети интернет</h3>
    </div>
  </div>
</template>

<script>
import CodeBox from '../../shared/CodeBox.vue';

export default {
  name: 'EnterPincode',

  components: {
    CodeBox,
  },

  props: ['data', 'meta'],

  data() {
    return {
      codeDigits: 4,
      autosendCode: true,

      form: {
        pincode: '',
        action: 'pincode',
      },
    };
  },

  computed: {
    isCodeValid() {
      return this.form.pincode.length === this.codeDigits;
    },
  },

  methods: {
    sendForm() {
      this.autosendCode = false;
      this.$emit('sendForm', this.form);
    },
  },
};
</script>
